module.exports = __webpack_public_path__ + "img/chefhero_ultimate_guide.4fc959d2.png";